import { BetSlipType } from '../../types';
import { useBetSlipStore, getComboOrSystemBets } from '../../useBetSlip';
import { BetHeaderTabs, BetHeaderTabType } from './BetHeaderTabs';
import { BetSlipContent } from './BetSlipContent';
import { QuickBetPanel } from './QuickBetPanel';
import { useTicketsData } from '../openBets/hook';

export { BetHeaderTabType };

/**
 * 投注单面板组件
 * 统一管理 Tab 切换和对应内容区域的显示
 * - BetSlip Tab: 投注类型切换、赔率设置、投注项列表和投注操作
 * - OpenBets Tab: 已下注订单列表
 */
export const BetPanel = (props: {
  /** 是否处于拖动状态 */
  isDragging?: boolean;
  /** 长按开始回调 */
  onPressStart?: (event: PointerEvent) => void;
  /** 长按结束回调 */
  onPressEnd?: () => void;
  /** 长按取消回调 */
  onPressCancel?: () => void;
  onClose: () => void;
}) => {
  const [store, dispatch, , settingExpanded] = useBetSlipStore();
  const { openBetsCount, fetchTickets } = useTicketsData();

  const setQuickBet = (val: boolean) => {
    dispatch({ type: 'SET_QUICK_BET', quickBet: val });
  };

  createEffect(() => {
    if (!account?.isLogin) {
      setQuickBet(false);
    }
  });

  createEffect(() => {
    if (store.quickBet && store.odds.length > 0) {
      dispatch({ type: 'CLEAR_ALL_BETS' });
    }
  });

  // 是否显示 Bet Slip 警告图标（同一比赛多选时）
  const showBetSlipWarning = createMemo(
    () =>
      store.betType !== BetSlipType.Single &&
      getComboOrSystemBets(store.odds).some((odd, idx) => odd.matchId === store.odds[idx - 1]?.matchId)
  );

  createEffect(
    on(
      () => settingExpanded(),
      (expand) => {
        if (expand && account?.isLogin) {
          fetchTickets();
        }
      }
    )
  );

  return (
    <div class="flex flex-col w-full max-h-[calc(100vh-4rem)]">
      {/* Tab 切换区域 - 固定在顶部 */}
      <div
        class={cx(
          'flex-shrink-0 sticky top-0 z-40 bg-betslip-header-bg betslip-drag-handle',
          props.isDragging ? 'cursor-move' : 'cursor-pointer',
          'border-b-[1px] border-solid border-main4'
        )}
        onPointerDown={(event) => props.onPressStart?.(event)}
        onPointerUp={() => props.onPressEnd?.()}
        onPointerCancel={() => props.onPressCancel?.()}
        onPointerLeave={() => props.onPressCancel?.()}
      >
        <BetHeaderTabs
          betSlipCount={store.odds.length}
          openBetsCount={openBetsCount()}
          showBetSlipWarning={showBetSlipWarning()}
          onClose={props.onClose}
          quickBet={store.quickBet}
          onQuickBetChange={setQuickBet}
          isLogin={!!account?.isLogin}
        />
      </div>

      {/* Tab 内容区域 */}
      <div class="flex-1 flex flex-col min-h-0">
        <Show when={store.quickBet} fallback={<BetSlipContent />}>
          <QuickBetPanel />
        </Show>
      </div>
    </div>
  );
};
